import React from "react";

import { devices } from "library/constants";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type Props = {
  showOnMobile?: boolean;
};
export function AppName({ showOnMobile = false }: Props) {
  const { t } = useTranslation();
  return (
    <Container $showOnMobile={showOnMobile}>
      {t("hbh.benefits.label")}
      <span
        style={{
          fontWeight: 600,
          textTransform: "uppercase",
        }}
      >
        HUB
      </span>
    </Container>
  );
}

const Container = styled.div<{ $showOnMobile: boolean }>`
  display: ${({ $showOnMobile }) => ($showOnMobile ? "flex" : "none")};
  color: ${({ theme }) => theme.palette.black};
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: lowercase;
  @media only screen and ${devices.md} {
    margin-left: 10px;
    display: flex;
  }
`;
